export var DcfExperience;
(function (DcfExperience) {
    DcfExperience["NONE"] = "NONE";
    DcfExperience["WITHIN_CHECKOUT"] = "WITHIN_CHECKOUT";
    DcfExperience["PAYMENT_SETTINGS"] = "PAYMENT_SETTINGS";
    DcfExperience["PAY_WITH_INSTALLMENTS"] = "PAY_WITH_INSTALLMENTS";
})(DcfExperience || (DcfExperience = {}));
//# sourceMappingURL=DcfExperience.js.map